import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';
import React from 'react';
import Loader from 'yoda-core-components/lib/components/Loader/Loader';

export default universal(
    universalImport({
        chunkName: () => 'LazyMarketplaceChunk',
        path: () => path.join(__dirname, './MarketplaceReturnWebview'),
        resolve: () => require.resolveWeak('./MarketplaceReturnWebview'),
        load: () =>
            Promise.all([
                import(/* webpackChunkName: "LazyMarketplaceChunk" */ './MarketplaceReturnWebview'),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => (
            <div className="loading-wrapper">
                <Loader keepOverlay loaderClass="lazy-loader" />
            </div>
        ),
        error: () => null,
        timeout: 60000,
    }
);
